import { Divider } from "antd";
import RowSalonListData from "./RowSalonListData";
import RowAppointmentsListData from "./RowAppointmentsListData";
import { formateTimeToAMPM } from "../../../utils/DateUtils";
type Props = {
  cols: string[];
  data: any;
  isDivider: boolean;
  type: string;
  maxCount?: number;
};

const FlexTable = ({
  cols = ["1", "2", "3", "4"],
  data,
  isDivider,
  type,
  maxCount,
}: Props) => {
  return (
    <div className="flex flex-col items-center ">
      <div
        style={{
          display: "grid",
          gap: "10px",
          gridTemplateColumns: `repeat(${cols?.length}, minmax(0, 1fr))`, // setting up dynamic columns based on 'cols' length
        }}
        className="items-center mb-2 w-full gap-2"
      >
        {cols?.map((e: any, i) => (
          <span
            className={`text-[#A3AED0] text-sm font-medium mx-auto justify-self-start items-start w-full mr-auto`}
          >
            {e}
          </span>
        ))}
      </div>
      {isDivider ? <Divider className="!mt-1 mb-2" /> : null}
      <div
        style={{
          display: "grid",
          gap: "10px",
          gridTemplateColumns: `repeat(${cols?.length}, minmax(0, 1fr))`, // setting up dynamic columns based on 'cols' length
        }}
        className={`grid grid-cols-${cols?.length} items-center mb-[6px] w-full`}
      >
        {type === "appointment"
          ? data.map((e: any, i: number) =>
              maxCount && i >= maxCount ? null : (
                <RowSalonListData
                  location={{
                    id: e?.id,
                    name: e?.name,
                    appointments: e?.appointments_count,
                    percent: e?.average_rating * 10,
                    imgUrl: e?.brand_logo,
                  }}
                />
              )
            )
          : data.map((e: any) => (
              <RowAppointmentsListData
                id={e?.id}
                name={e?.location_name}
                status={e?.status}
                time={
                  formateTimeToAMPM(e?.start_time, "en") +
                  " - " +
                  formateTimeToAMPM(e?.finish_time, "en")
                }
              />
            ))}
      </div>
    </div>
  );
};

export default FlexTable;
